export const getToggleLabel = (isPlanner: boolean): string =>
  isPlanner ? 'Switch to the legacy deal form' : 'Try the deal creation experience';
